<div class="p-col-12 p-lg-12">
  <div class="ui-g card">
    <div class="ui-g-12 ui-md-12 ui-lg-12">
      @for (message of msgs; track message) {
        <p-message [life]="3000" [text]="message.detail"></p-message>
      }
      @if (showForm) {
        <form [formGroup]="paymentBatchForm" (ngSubmit)="onSubmit()">
          <div class="ui-g">
            <div class="ui-g-12 ui-md-8 ui-lg-6">
              <div class="reqfields">
                <span class="indicate">*</span> required fields
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Batch Create Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="paymentBatchScheduleDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Anticipated Payment Date <span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="anticipatedPaymentDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">Actual Payment Central Date</div>
                <div class="ui-g-12 ui-md-7">
                  <p-datepicker
                    formControlName="actualPaymentCentralDate"
                    [readonlyInput]="true"
                    [iconDisplay]="'input'"
                    [showIcon]="true"></p-datepicker>
                </div>
              </div>

              <div class="ui-g form-group">
                <div class="ui-g-12 ui-md-5">
                  Payment Batch Status<span class="indicate">*</span>
                </div>
                <div class="ui-g-12 ui-md-7">
                  <p-select
                    [options]="paymentBatchStatus"
                    placeholder="Select"
                    formControlName="paymentBatchStatus"
                    optionLabel="eventPaymentBatchStatus"></p-select>
                </div>
              </div>
            </div>
          </div>

          <div class="ui-g bdr">
            @if (loading) {
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
            }
            <div class="ui-g-12 ui-md-12 ui-lg-12">
              <p-table
                #dt
                [columns]="engcols"
                editMode="row"
                [(selection)]="selectedEvents"
                dataKey="eventId"
                [value]="eventList"
                selectionMode="multiple"
                [showLoader]="true"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                scrollHeight="500px"
                frozenWidth="275px"
                [loadingIcon]="loadingIcon"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                (onPage)="pageChange($event)"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="top"
                (onFilter)="applyFilter($event)">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        dt.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        dt.filters['global']
                          ? $any(dt.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfo
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="reset()"
                        (keydown.enter)="reset()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>
                <ng-template #header let-columns>
                  <tr>
                    <th class="dashtable colchck" pFrozenColumn>
                      <p-tableHeaderCheckbox
                        [disabled]="editing"></p-tableHeaderCheckbox>
                    </th>
                    <th class="coleditrow" pFrozenColumn></th>
                    <th
                      [pSortableColumn]="'eventId'"
                      class="colsmall"
                      pFrozenColumn>
                      {{ engagementId
                      }}<p-sortIcon [field]="'eventId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'eventName'" class="colmedium">
                      {{ engagementName
                      }}<p-sortIcon [field]="'eventName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'eventTypeName'" class="colmedium">
                      {{ engagementSubType
                      }}<p-sortIcon [field]="'eventTypeName'"></p-sortIcon>
                    </th>
                    @if (showTargetProduct) {
                      <th
                        [pSortableColumn]="'eventTargetProductName'"
                        class="colmedium">
                        Target Product<p-sortIcon
                          [field]="'eventTargetProductName'"></p-sortIcon>
                      </th>
                    }
                    <th [pSortableColumn]="'partnerName'" class="colsmall">
                      Partner Name<p-sortIcon
                        [field]="'partnerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payeeId'" class="colsmall">
                      Payee ID<p-sortIcon [field]="'payeeId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerLocation'" class="colsmall">
                      Partner Location<p-sortIcon
                        [field]="'partnerLocation'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'fiscalYear'" class="colsmall">
                      Fiscal Year<p-sortIcon
                        [field]="'fiscalYear'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'profileStatus'" class="colsmall">
                      ProfileStatus<p-sortIcon
                        [field]="'profileStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerPriority'" class="colsmall">
                      Partner Priority<p-sortIcon
                        [field]="'partnerPriority'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'blockedStatus'" class="colsmall">
                      Blocked Status<p-sortIcon
                        [field]="'blockedStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerId'" class="colsmall">
                      Partner ID<p-sortIcon [field]="'partnerId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'payeeName'" class="colsmall">
                      Payee Name<p-sortIcon [field]="'payeeName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactName'" class="colsmall">
                      Contact Name<p-sortIcon
                        [field]="'contactName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'contactEmail'" class="colsmall">
                      Contact Email<p-sortIcon
                        [field]="'contactEmail'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'emailLanguage'" class="colsmall">
                      Email Language<p-sortIcon
                        [field]="'emailLanguage'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'accountCode'" class="colsmall">
                      Account Code<p-sortIcon
                        [field]="'accountCode'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'internalOrderOrCostCenter'"
                      class="colsmall">
                      Internal Order or<br />Cost Center<p-sortIcon
                        [field]="'internalOrderOrCostCenter'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'currency'" class="colxsmall">
                      Currency<p-sortIcon [field]="'currency'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'amount'" class="colxsmall">
                      Amount<p-sortIcon [field]="'amount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'netAmount'" class="colxsmall">
                      Net Amount<p-sortIcon [field]="'netAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'taxAmount'" class="colxsmall">
                      Tax Amount<p-sortIcon [field]="'taxAmount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'msInvoiceNumber'" class="colmedium">
                      MS Invoice Number<p-sortIcon
                        [field]="'msInvoiceNumber'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'msInvoicePaidDate'"
                      class="colmedium">
                      MS Invoice Paid Date<p-sortIcon
                        [field]="'msInvoicePaidDate'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'paymentCentralTransactionId'"
                      class="collarge">
                      Payment Central<br />Transaction ID<p-sortIcon
                        [field]="'paymentCentralTransactionId'"></p-sortIcon>
                    </th>
                  </tr>
                  <tr>
                    <th class="colchk" pFrozenColumn></th>
                    <th class="coleditrow" pFrozenColumn></th>
                    <th class="dashtable colsmall" pFrozenColumn>
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'eventId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['eventId']
                            ? $any(dt.filters['eventId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'eventName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['eventName']
                            ? $any(dt.filters['eventName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'eventTypeName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['eventTypeName']
                            ? $any(dt.filters['eventTypeName']).value
                            : ''
                        " />
                    </th>
                    @if (showTargetProduct) {
                      <th class="dashtable colmedium">
                        <input
                          pInputText
                          type="text"
                          (input)="
                            dt.filter(
                              $any($event.target).value,
                              'eventTargetProductName',
                              'contains'
                            )
                          "
                          [value]="
                            dt.filters['eventTargetProductName']
                              ? $any(dt.filters['eventTargetProductName']).value
                              : ''
                          " />
                      </th>
                    }
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerName']
                            ? $any(dt.filters['partnerName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'payeeId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['payeeId']
                            ? $any(dt.filters['payeeId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerLocation',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerLocation']
                            ? $any(dt.filters['partnerLocation']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'fiscalYear',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['fiscalYear']
                            ? $any(dt.filters['fiscalYear']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'profileStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['profileStatus']
                            ? $any(dt.filters['profileStatus']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerPriority',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerPriority']
                            ? $any(dt.filters['partnerPriority']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'blockedStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['blockedStatus']
                            ? $any(dt.filters['blockedStatus']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerId']
                            ? $any(dt.filters['partnerId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'payeeName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['payeeName']
                            ? $any(dt.filters['payeeName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'contactName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['contactName']
                            ? $any(dt.filters['contactName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'contactEmail',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['contactEmail']
                            ? $any(dt.filters['contactEmail']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'emailLanguage',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['emailLanguage']
                            ? $any(dt.filters['emailLanguage']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'accountCode',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['accountCode']
                            ? $any(dt.filters['accountCode']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'internalOrderOrCostCenter',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['internalOrderOrCostCenter']
                            ? $any(dt.filters['internalOrderOrCostCenter'])
                                .value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'currency',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['currency']
                            ? $any(dt.filters['currency']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'amount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['amount']
                            ? $any(dt.filters['amount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'netAmount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['netAmount']
                            ? $any(dt.filters['netAmount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colxsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'taxAmount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['taxAmount']
                            ? $any(dt.filters['taxAmount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'msInvoiceNumber',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['msInvoiceNumber']
                            ? $any(dt.filters['msInvoiceNumber']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'msInvoicePaidDate',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['msInvoicePaidDate']
                            ? $any(dt.filters['msInvoicePaidDate']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable collarge">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'paymentCentralTransactionId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['paymentCentralTransactionId']
                            ? $any(dt.filters['paymentCentralTransactionId'])
                                .value
                            : ''
                        " />
                    </th>
                  </tr>
                </ng-template>
                <ng-template
                  #body
                  let-rowData
                  let-editing="editing"
                  let-columns="columns"
                  let-ri="rowIndex">
                  <tr [pEditableRow]="rowData" class="wa-uneven-height-fix">
                    <td
                      class="colchck"
                      class="wa-uneven-height-fix"
                      pFrozenColumn>
                      <p-checkbox
                        name="chcklist"
                        [disabled]="editing"
                        inputId="eng_chk_{{ rowData.eventId }}"
                        [value]="rowData"
                        formControlName="selectedEvents"
                        (onChange)="selectRow($event, rowData)"
                        [(ngModel)]="selectedEvents"></p-checkbox>
                    </td>
                    <td
                      class="dashtable coleditrow"
                      style="text-align: center"
                      pFrozenColumn></td>
                    <td class="colsmall" pFrozenColumn>
                      {{ rowData.eventId }}
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.eventName }}"
                        >{{ rowData.eventName }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.eventTypeName }}"
                        >{{ rowData.eventTypeName }}</span
                      >
                    </td>
                    @if (showTargetProduct) {
                      <td class="colmedium">
                        <span
                          tooltipPosition="top"
                          pTooltip="{{ rowData.eventTargetProductName }}"
                          >{{ rowData.eventTargetProductName }}</span
                        >
                      </td>
                    }
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerName }}"
                        >{{ rowData.partnerName }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.payeeId }}"
                        >{{ rowData.payeeId }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerLocation }}"
                        >{{ rowData.partnerLocation }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.fiscalYear }}"
                        >{{ rowData.fiscalYear }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.profileStatus }}"
                        >{{ rowData.profileStatus }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerPriority }}"
                        >{{ rowData.partnerPriority }}</span
                      >
                    </td>
                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.blockedStatus }}"
                        >{{ rowData.blockedStatus }}</span
                      >
                    </td>

                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.partnerId"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.partnerId }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.payeeName"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.payeeName }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.contactName"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.contactName }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.contactEmail"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.contactEmail }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.emailLanguage"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.emailLanguage }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.accountCode"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.accountCode }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="
                              firstEditInitEng.internalOrderOrCostCenter
                            "
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.internalOrderOrCostCenter }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.currency"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.currency }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.amount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.amount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.netAmount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.netAmount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colxsmall">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.taxAmount"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          {{ rowData.taxAmount }}
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colmedium">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="firstEditInitEng.msInvoiceNumber"
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          @if (
                            rowData.msInvoiceNumber !== null &&
                            rowData.msInvoiceNumber !== ''
                          ) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{ rowData.msInvoiceNumber }}"
                              >{{ rowData.msInvoiceNumber }}</span
                            >
                          }
                          @if (
                            rowData.msInvoiceNumber === null ||
                            rowData.msInvoiceNumber === ''
                          ) {
                            <span>Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable colcalendar">
                      <p-cellEditor>
                        <ng-template #input>
                          <p-datepicker
                            dataType="date"
                            dateFormat="mm/dd/yy"
                            [(ngModel)]="firstEditInitEng.msInvoicePaidDate"
                            [ngModelOptions]="{ standalone: true }"
                            [iconDisplay]="'input'"
                            [showIcon]="true"></p-datepicker>
                        </ng-template>
                        <ng-template #output>
                          @if (rowData.msInvoicePaidDate !== null) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{
                                rowData.msInvoicePaidDate | date: 'MM/dd/yyyy'
                              }}"
                              >{{
                                rowData.msInvoicePaidDate | date: 'MM/dd/yyyy'
                              }}</span
                            >
                            @if (rowData.msInvoicePaidDate === null) {
                              <span>Missing</span>
                            }
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                    <td class="dashtable collarge">
                      <p-cellEditor>
                        <ng-template #input>
                          <input
                            pInputText
                            type="text"
                            [(ngModel)]="
                              firstEditInitEng.paymentCentralTransactionId
                            "
                            [ngModelOptions]="{ standalone: true }" />
                        </ng-template>
                        <ng-template #output>
                          @if (
                            rowData.paymentCentralTransactionId !== null &&
                            rowData.paymentCentralTransactionId !== ''
                          ) {
                            <span
                              tooltipPosition="top"
                              pTooltip="{{
                                rowData.paymentCentralTransactionId
                              }}"
                              >{{ rowData.paymentCentralTransactionId }}</span
                            >
                          }
                          @if (
                            rowData.paymentCentralTransactionId === null ||
                            rowData.paymentCentralTransactionId === ''
                          ) {
                            <span tooltipPosition="top">Missing</span>
                          }
                        </ng-template>
                      </p-cellEditor>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
          @for (message of msgs; track message) {
            <p-message [life]="3000" [text]="message.detail"></p-message>
          }
          <div class="ui-g">
            <div class="ui-g-12 ui-md-12 ui-lg-12 mar10">
              <button
                type="submit"
                pButton
                [disabled]="!paymentBatchForm.valid || disableSubmit"
                class="flat btnmr">
                Submit
              </button>
              <button
                type="button"
                pButton
                (click)="cancelSearchNav()"
                class="ui-button-secondary flat">
                Cancel
              </button>
            </div>
          </div>
        </form>
      }
    </div>
  </div>
</div>
